<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      device: "PC",
    }
  },
  mounted() {
    const isMobile = this.isMobileDevice()
    const currentPath = window.location.pathname
    
    // 检查当前路径是否已经是正确的设备路径
    const isCorrectDevicePath = (isMobile && currentPath.startsWith('/mobile/')) || 
                                (!isMobile && currentPath.startsWith('/website/'))
    
    // 如果已经是正确的设备路径，且不是根路径，则不做处理
    if (isCorrectDevicePath && currentPath !== '/') {
      return
    }
    
    // 解析当前路径的页面部分
    let pagePath = ''
    if (currentPath.startsWith('/mobile/')) {
      pagePath = currentPath.split('/mobile/')[1]
    } else if (currentPath.startsWith('/website/')) {
      pagePath = currentPath.split('/website/')[1]
    } else {
      // 从根路径或其他路径解析页面部分
      const pathParts = currentPath.split('/').filter(Boolean)
      pagePath = pathParts[pathParts.length - 1] || 'home'
    }
    
    // 构建目标路径
    const targetPath = isMobile ? `/mobile/${pagePath}` : `/website/${pagePath}`
    
    // 只有当目标路径与当前路径不同时才进行跳转
    if (targetPath !== currentPath) {
      console.log(`综合判断：${isMobile ? '移动端' : 'PC端'}设备，重定向到：${targetPath}`)
      this.$router.replace(targetPath)
    }
  },
  methods: {
    isMobileDevice() {
      // User-Agent检测
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const isMobileUA =
        /android|avantgo|blackberry|iemobile|ipad|iphone|ipod|j2me|midp|mobile|opera mini|phone|palm|pocket|psp|symbian|up\.browser|up\.link|wap|windows ce|xda|xiino/i.test(
          userAgent
        )

      // 屏幕尺寸检测
      const isSmallScreen = window.innerWidth <= 768

      // 触摸事件检测
      const isTouchScreen =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0

      // 综合判断：如果User-Agent是移动端，或者屏幕小且支持触摸，则认为是移动端
      return isMobileUA || (isSmallScreen && isTouchScreen)
    },
  },
}
</script>

<style>
[v-cloak] {
  display: none;
}
:root {
  --scale: 1;
}
body {
  margin: 0;
}
#app {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #020206;
  box-sizing: border-box;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
